import RestResource from '../rest.service';
export default class SimpleNegotiationsService extends RestResource {
  map(payload) {
    return {
      observations: payload.observations,
      user_id: payload.producerId,
      client_id: payload.clientId,
      type: payload.type,
      state: payload.state
    };
  }

  constructor(api) {
    super(api, 'simple-negotiations', 'api');
  }
}
